import useVelocityAccountStore from 'src/stores/useVelocityAccountsStore';

export const useBalanceCount = () => {
	const balanceCount = useVelocityAccountStore((s) => {
		const currentAccountKey = s.currentUserKey;
		return s.accounts[currentAccountKey ?? '']?.balanceCount ?? 0;
	});
	return balanceCount;
};
